import { useHistory } from "react-router-dom";
import { useTranslation } from "Shared/util/custom-hooks";
import PropTypes from "prop-types";
import { SettingsCard } from "Shared/components/cards";

const KycSettingsCard = ({ completed, className }) => {
    const history = useHistory();
    const t = useTranslation((x) => x.company_settings.kyc_settings_card);

    const handleActionClick = () => history.push("/company-settings/kyc");

    return (
        <SettingsCard
            status={{
                type: completed ? "VALID" : "INVALID",
                text: completed ? t.submitted : t.to_complete,
            }}
            header={{
                text: t.know_your_customer,
            }}
            content={t.know_your_customer_description}
            action={{
                svg: "/caret-right.svg",
                onClick: handleActionClick,
            }}
            className={className || ""}
        />
    );
};

KycSettingsCard.propTypes = {
    completed: PropTypes.bool.isRequired,
    className: PropTypes.string,
};

export default KycSettingsCard;
